import { render, staticRenderFns } from "./TagsList.vue?vue&type=template&id=76f2e2be&"
import script from "./TagsList.vue?vue&type=script&lang=js&"
export * from "./TagsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports